<template>
	<div class="pagination">
		<v-pagination
			v-model="pagination.page"
			:circle="circle"
			:total-visible="totalVisible"
			:length="pages"
			v-if="pages > 1"
		></v-pagination>
	</div>
</template>

<script>
export default {
	data: () => ({}),

	props: {
		pagination: {
			default: {
				rowsPerPage: 10
			}
		},
		totalVisible: {
			default: 7
		},
		pages: {
			default: null
		},
		circle: {
			default: false
		}
	},

	watch: {
		pages() {
			if (this.pagination.page > this.pages) {
				this.pagination.page = this.pages ? this.pages : 1;
			}
		}
	}
};
</script>
